import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { handleLogout } from "containers/Login/reducer";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import LookerSettingsModal from "components/LookerSettings/LookerSettingsModal";

import * as lookerSettingsReducer from "containers/LookerSettings/reducer";

class LookerSettingsModalContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: true
    };
  }

  render() {
    return <LookerSettingsModal {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateIsOpen: (isOpen) => dispatch(lookerSettingsReducer.updateIsOpen(isOpen)),
  saveSettings: (settings) => dispatch(lookerSettingsReducer.saveSettings(settings))
});

const mapStateToProps = (state) => ({
  isOpen: lookerSettingsReducer.getIsOpen(state),
  userAttributes: lookerSettingsReducer.getLookerUserAttributes(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(LookerSettingsModalContainer);
